// エラー / 成功 / 情報 の共通バナー。
// 既存の各画面で inline に <p className="text-sm text-red-600">...</p> と
// 書いていた箇所を段階的にこれに置換する。error は role="alert"。
import type { ReactNode } from "react";

export type BannerTone = "error" | "success" | "info" | "warning";

const TONE: Record<BannerTone, string> = {
  error: "bg-red-50 text-red-700 border-red-200",
  success: "bg-green-50 text-green-700 border-green-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  warning: "bg-yellow-50 text-yellow-800 border-yellow-200",
};

interface Props {
  tone?: BannerTone;
  className?: string;
  children: ReactNode;
}

export function Banner({ tone = "info", className, children }: Props) {
  return (
    <div
      className={`rounded border px-3 py-2 text-sm ${TONE[tone]} ${className ?? ""}`.trim()}
      role={tone === "error" ? "alert" : undefined}
    >
      {children}
    </div>
  );
}

export const ErrorBanner = (p: Omit<Props, "tone">) => (
  <Banner tone="error" {...p} />
);
export const SuccessBanner = (p: Omit<Props, "tone">) => (
  <Banner tone="success" {...p} />
);
